import ExtensionCard from './ExtensionCard'

export default ExtensionCard
